module.exports = __webpack_public_path__ + "static/media/Dual_6910.f8bbb40e.jpg";